import UserService from '@/api/userService';

import { defineStore } from 'pinia';

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    user: {},
    drawer: true,
  }),
  persist: true,
  actions: {
    async getInfo(type: string) {
      if (type === 'artist') {
        const data = await UserService.getInfo(type);
        this.user = data.user;
        return data.artist;
      } else if (type === 'gallery') {
        const data = await UserService.getInfo(type);
        this.user = data;
        return data.gallery.user;
      } else if (type === 'private_seller') {
        const data = await UserService.getInfo(type);
        this.user = data;
        return data.user;
      }
    },
    clearState() {
      this.user = {};
    },
  },
});
